import { render, staticRenderFns } from "./SourceListToSchool.vue?vue&type=template&id=58268a7b"
import script from "./SourceListToSchool.vue?vue&type=script&lang=ts"
export * from "./SourceListToSchool.vue?vue&type=script&lang=ts"
import style0 from "./SourceListToSchool.vue?vue&type=style&index=0&id=58268a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports